import script from "./YouTubeMusic.vue?vue&type=script&setup=true&lang=js"
export * from "./YouTubeMusic.vue?vue&type=script&setup=true&lang=js"

import "./YouTubeMusic.vue?vue&type=style&index=0&id=a2621e8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2621e8e"]])

export default __exports__